export function getMetadataKeyByValue(section, value) {
  try {
    const raw = localStorage.getItem("metadata");
    if (!raw) return null;

    const parsed = JSON.parse(raw);             // top-level object
    const metadata = JSON.parse(parsed.metadata); // nested stringified JSON

    
    const sectionData = metadata[section];
    if (!sectionData) return null;

    const matchedKey = Object.keys(sectionData).find(
      (key) => sectionData[key] === value
    );

    return matchedKey || null;
  } catch (error) {
    console.error("Error reading metadata from localStorage:", error);
    return null;
  }
}
